"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0; // ARCHITECT-MIXINS [ ADD > PAINT ] ############################################
// 1. DEPENDENCIES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 1.1. EXTERNAL DEPENDENCIES ..................................................
// 1.1. END ....................................................................
// 1.2. INTERNAL DEPENDENCIES ..................................................
// 1.2. END ....................................................................
// 1.3. FUNCTIONS ..............................................................

var textLightMode = function textLightMode() {
  return "\n    color: var(--color-white);\n\n    h1, h2, h3, h4, h5, h6 {\n      color: var(--color-white);\n    }\n\n    strong {\n      color: var(--color-accent);\n    }\n    \n    blockquote {\n      small {\n        color: var(--color-accent);\n      }\n    }\n\n    /* Secondary */\n    --btn-secondary--color:   var(--color-accent);\n    --btn-secondary--colorH:  var(--color-white);\n    --btn-secondary--bg:      'transparent';\n    --btn-secondary--bgH:     'transparent';\n    --btn-secondary--border:  var(--color-accent);\n    --btn-secondary--borderH: var(--color-white);\n    /* End */\n  ";
};

var gradientBlueUp = function gradientBlueUp() {
  return "\n    background: linear-gradient(to top, var(--color-secondary), var(--color-primary)) !important;\n    &:before {\n      background: var(--color-primary) !important;\n    }\n    &:after {\n      background: var(--color-secondary) !important;\n    }\n\n  ";
};

var gradientBlueDown = function gradientBlueDown() {
  return "\n    background: linear-gradient(to bottom, var(--color-secondary), var(--color-primary)) !important;\n    &:before {\n      background: var(--color-secondary) !important;\n    }\n    &:after {\n      background: var(--color-primary) !important;\n    }\n\n  ";
}; // 1.3. END ....................................................................
// 1. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. COMPONENT ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++


var _default = function _default(color) {
  switch (color) {
    case 'white':
      return "\n        background: var(--color-white)!important;\n        &:before, &:after {\n          background: var(--color-white)!important;\n        }\n      ";

    case 'blue':
      return "\n        background: var(--color-primary)!important;\n        ".concat(textLightMode(), ";\n        &:before, &:after {\n          background: var(--color-primary)!important;\n        }\n      ");

    case 'blueDark':
      return "\n        background: var(--color-secondary)!important;\n        ".concat(textLightMode(), ";\n        &:before, &:after {\n          background: var(--color-secondary)!important;\n        }\n      ");

    case 'simple-gradient':
      return "\n        background: var( --gradient-basic);\n        &:before {\n          background: var(--color-secondary)!important;\n        }\n        &:after {\n          background: var(--color-primary)!important;\n        }\n      ";

    case 'gradientBlueUp':
      return "\n        ".concat(gradientBlueUp(), ";\n        ").concat(textLightMode(), ";\n      ");

    case 'gradientBlueDown':
      return "\n        ".concat(gradientBlueDown(), ";\n        ").concat(textLightMode(), ";\n      ");

    default:
      return "";
  }
}; // 2. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// END OF FILE #################################################################


exports["default"] = _default;